import React, { Component } from 'react';
import Select, { createFilter } from 'react-select';
import Creatable from 'react-select/creatable';

class CreatableSelectInputField extends Component {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
    this.getOptionLabel = this.getOptionLabel.bind(this);
    this.getOptionValue = this.getOptionValue.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const nextPropsStr = JSON.stringify(nextProps);
    const thisPropsStr = JSON.stringify(this.props);
    if (
      nextPropsStr === thisPropsStr
    ) {
      return false;
    }
    return true;
  }

  handleOnChange(data) {
    const { onPostChange, input, fieldId } = this.props;
    const value = fieldId ? (data || {})[fieldId] : data;
    input.onChange(value);

    if (onPostChange) onPostChange(data);
  }

  getOptionLabel(data) {
    const { fieldLabel } = this.props;
    const label = data[fieldLabel];
    return label;
  }

  getOptionValue(data) {
    const { fieldId } = this.props;
    if (fieldId) {
      const value = data[fieldId];
      return value;
    }

    return data;
  }

  getValue() {
    const { listOptions, input, fieldId, defaultValue, name } = this.props;
    const { value } = input;

    if (fieldId) {
      return (
        (listOptions || []).find((data) => data[fieldId] === value) || null
      );
    }

    if (!value && defaultValue) {
      input.onChange(name, defaultValue);
    }

    if (value || defaultValue) {
      return value ? value : defaultValue;
    }

    return null;
  }

  render() {
    const {
      id,
      input,
      name,
      label,
      required,
      listOptions = [],
      groupedListOptions,
      isDisabled,
      isClearable,
      isCreatable,
      isLoading,
      onCreateOption,
      getOptionLabel,
      getOptionValue,
      formatCreateLabel,
      getValue,
      defaultValue,
      createOptionPosition,
      multiple,
    } = this.props;

    const value = getValue ? getValue.bind(this)() : this.getValue();

    const props = {
      ...input,
      id,
      name,
      value,
      isLoading,
      isDisabled,
      isClearable,
      defaultValue,
      createOptionPosition,
      filterOption: createFilter({ ignoreAccents: false }),

      options: groupedListOptions || listOptions,
      getOptionLabel: getOptionLabel || this.getOptionLabel,
      getOptionValue: getOptionValue || this.getOptionValue,
      formatCreateLabel: formatCreateLabel,
      onChange: this.handleOnChange,
      onBlur: () => input.onBlur(),
      isMulti: multiple,
    };

    const classNames = [];
    classNames.push('ui');
    if (required) classNames.push('required');
    classNames.push('field');

    const className = classNames.join(' ');

    if (isCreatable) {
      return (
        <div className={className}>
          {label && <label>{label}</label>}
          <Creatable
            {...props}
            menuPortalTarget={document.body}
            onCreateOption={onCreateOption}
          />
        </div>
      );
    }

    return (
      <div className={className}>
        {label && <label>{label}</label>}
        <Select {...props} />
      </div>
    );
  }
}

export default CreatableSelectInputField;
